import { Component, inject } from '@angular/core';
import { Router, RouterModule, RouterOutlet } from '@angular/router';
import { NucButtonDestructiveComponent } from '@relayter/rubber-duck';
import { AuthenticationService } from '../../api/services/authentication.service';
import { Toaster } from '../../classes/toaster.class';

@Component({
    selector: 'om-admin-container',
    templateUrl: './admin-container.component.html',
    styleUrls: ['./admin-container.component.scss'],
    imports: [RouterModule, RouterOutlet, NucButtonDestructiveComponent]
})
export class AdminContainerComponent {
    private readonly authenticationService = inject(AuthenticationService);
    private readonly router = inject(Router);

    public btnLogoutClicked(): void {
        this.authenticationService.logout().subscribe({
            next: () => {
                this.router.navigate(['/login']).catch(() => undefined);
            },
            error: (error: unknown) => {
                Toaster.handleApiError(error as any);
                this.router.navigate(['/login']).catch(() => undefined);
            }
        });
    }
}
